import React from "react";
import "./TagVehicle.scss";
import { useTranslation } from "react-i18next";
import { ExceptionOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { CRIMINAL_STATUS } from "constants/common";

/*
- type dùng để xác định tag vi phạm này đã được xử lí hay chưa
- type = "danger" : Chưa xử lí
- type = "success" : Đã xử lí
*/

const DISPLAY_WARNING_SIGN = {
  NO_DISPLAY_WARNING_SIGN: undefined,
  DANGER: "danger",
  ALL_HANDLED: "allhandled"
}

function _checkDisplayType(crimesRecords) {
  if (!crimesRecords || crimesRecords.length === 0) {
    return DISPLAY_WARNING_SIGN.NO_DISPLAY_WARNING_SIGN;
  }

  let _allHandled = 0;
  //Nếu có 1 record chưa xử lý thì cảnh báo
  for (let i = 0; i < crimesRecords.length; i++) {
    const _recordData = crimesRecords[i];
    if (_recordData.crimeRecordStatus === CRIMINAL_STATUS.NO) {
      return DISPLAY_WARNING_SIGN.DANGER
    } else if (_recordData.crimeRecordStatus === CRIMINAL_STATUS.YES) {
      _allHandled++;
    }
  }

  // nếu tất cả đã được xử lý
  if (crimesRecords.length > 0 && _allHandled > 0 && _allHandled === crimesRecords.length) {
    return DISPLAY_WARNING_SIGN.ALL_HANDLED
  }

  //default khong hien thi gi
  return DISPLAY_WARNING_SIGN.NO_DISPLAY_WARNING_SIGN;
}
const TagVehicleWarn = ({ onClick, children, crimesRecords }) => {
  const { t: translation } = useTranslation();
  // Ghi đè theo logic mới, không xử lý bên ngoài
  // Xử lý tại đây để đảm bảo tất cả mọi nơi đều đồng bộ
  const type = _checkDisplayType(crimesRecords);
  return (
    <div style={{ margin: "5px" }}>
      <div className="d-flex justify-content-around align-items-start">
        <div className="d-flex flex-column">
          <span
            className="accreditation__licenplates"
            style={{ fontWeight: 600 }}
          >
            {children}
          </span>

          {type === DISPLAY_WARNING_SIGN.DANGER || type === DISPLAY_WARNING_SIGN.ALL_HANDLED ? (
            <span
              className={"text-very-small"}
              style={{
                color:
                  type === DISPLAY_WARNING_SIGN.DANGER ? "var(--bs-danger)" : "var(--bs-success)",
              }}
            >
              {type === DISPLAY_WARNING_SIGN.DANGER
                ? translation("punish.warning")
                : translation("punish.crimesHandled")}
            </span>
          ) : null}
        </div>

        {type === DISPLAY_WARNING_SIGN.DANGER || type === DISPLAY_WARNING_SIGN.ALL_HANDLED ? (
          <Tooltip
            title={
              type === DISPLAY_WARNING_SIGN.DANGER
                ? translation("punish.warning")
                : translation("punish.crimesHandled")
            }
          >
            <ExceptionOutlined
              style={{
                color:
                  type === DISPLAY_WARNING_SIGN.DANGER ? "var(--bs-danger)" : "var(--bs-success)",
                cursor: "pointer",
                marginTop: "5px",
              }}
              className="text-large"
              onClick={() => onClick && onClick()}
            />
          </Tooltip>
        ) : null}
      </div>
    </div>
  );
};

export default TagVehicleWarn;
